var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServiceListSelect',{staticStyle:{"width":"100%"},attrs:{"locationId":_vm.locationId,"multiselect":"","type":"service"},on:{"input":_vm.onServicesSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }